import { render, staticRenderFns } from "./TableSelect.vue?vue&type=template&id=8ff22660&"
import script from "./TableSelect.vue?vue&type=script&lang=ts&"
export * from "./TableSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TableSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports